import { useEffect, useState } from "react";
import { navItems } from "@/mocks/homeData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/90 backdrop-blur-md shadow-sm shadow-background-300/40"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        <a
          href="#home"
          className="flex items-center gap-2 whitespace-nowrap"
          aria-label="回到今日大瓜首页"
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-xl" aria-hidden="true"></i>
          </span>
          <span
            className={`font-display text-2xl leading-none ${
              solid ? "text-primary-700" : "text-primary-600"
            }`}
          >
            今日大瓜
          </span>
        </a>

        <nav
          aria-label="主导航"
          className="hidden items-center gap-1 lg:flex"
        >
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                solid
                  ? "text-foreground-700 hover:bg-primary-100 hover:text-primary-800"
                  : "text-foreground-800 hover:bg-background-50/60 hover:text-primary-700"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#join"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            订阅瓜报
            <i className="ri-mail-send-line ml-2 text-base" aria-hidden="true"></i>
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="展开或收起导航菜单"
            aria-expanded={open}
            className={`flex h-10 w-10 items-center justify-center rounded-full transition-colors lg:hidden ${
              solid ? "bg-background-200/70 text-foreground-900" : "bg-background-50/60 text-foreground-900"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <nav
          aria-label="移动端导航"
          className="border-t border-background-200/70 bg-background-50/95 px-4 pb-4 backdrop-blur-md lg:hidden"
        >
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              className="block rounded-xl px-4 py-3 text-base text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-800"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#join"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center rounded-full bg-primary-500 px-5 py-3 text-base font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅瓜报
            <i className="ri-mail-send-line ml-2 text-lg" aria-hidden="true"></i>
          </a>
        </nav>
      )}
    </header>
  );
}